import { Component } from 'react';
import cx from 'classnames';
import { handleShare } from 'utils';
import styles from './styles.css';

export default class Social extends Component {
	render() {
		return (
			<div className={styles.social}>
				<div className={styles.label}>Share</div>

				<div className={cx(styles.item, styles.facebook)} onClick={() => handleShare('facebook')} />
				<div className={cx(styles.item, styles.twitter)} onClick={() => handleShare('twitter')} />
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./components/Social/index.js
 **/